module.exports = __webpack_public_path__ + "static-prod-1/img/art_list_log.618bd522.png";